import { Typography } from '@mui/material';
import DataBlock from 'components/shared/data/data_block';
import DataCard from 'components/shared/data/data_card';
import DataLabel from 'components/shared/data/data_label';
import { Flex } from 'components/shared/flex';
import { Hint } from 'components/shared/hint';
import ThemedButton from 'components/shared/themed_button';
import { Instrument } from 'entities/instrument';
import React from 'react';

type Props = {
  instrument: Instrument;
  onClickEdit?: () => void;
};
const InstrumentProofreadExAttributeDefaultsDataCard: React.FC<Props> = (props) => {
  const defaults = props.instrument.proofreadExAttributeDefaults || [];

  if (defaults.length === 0 && props.instrument.requireProofread) return null;

  return (
    <DataCard>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Typography variant="h6">校正管理情報</Typography>
          <Hint
            title={
              <>
                校正計画作成時に機器を絞り込むための設定です。
                <br />
                ドロップダウン型の校正管理情報のみが対象です。
              </>
            }
          />
        </Flex>
        {props.instrument.requireProofread && props.onClickEdit && (
          <ThemedButton color="primary" onClick={props.onClickEdit}>
            編集
          </ThemedButton>
        )}
      </Flex>
      {props.instrument.requireProofread ? (
        <DataBlock noBorder>
          {defaults.map((d, i) => (
            <DataLabel key={d.exColumnId || i} label={d.exColumnName || ''} value={d.value || '未設定'} width="30%" />
          ))}
        </DataBlock>
      ) : (
        <>校正管理対象外です</>
      )}
    </DataCard>
  );
};

export default InstrumentProofreadExAttributeDefaultsDataCard;
